<div class="row mt-2 no-gutters">
  <div class="col">
    <small *ngIf="accountCategory== 'RENTAL_FLEET'"><a [routerLink]="['/rental-fleet']" class="text-secondary">Developer
        Portal</a>
      /<a [routerLink]="['/vehicle-trips']" class="text-secondary"> Vehicle Trips</a> /<span class="text-secondary">
        Events</span></small>
    <small
      *ngIf="accountCategory== 'FLEET_MANAGEMENT_COMPANY' || accountCategory == 'MOBILITY_COMPANY' || accountCategory == 'FIELD_SERVICE_COMPANY'"><a
        [routerLink]="['/commercial-fleet']" class="text-secondary">Developer Portal</a>
      /<a [routerLink]="['/vehicle-trips']" class="text-secondary"> Vehicle Trips</a> /<span class="text-secondary">
        Events</span></small>
    <small *ngIf="accountType== 'VEHICLE_SERVICE_PROVIDER'"><a [routerLink]="['/service-provider/dashboard']"
        class="text-secondary">Developer Portal</a>
      /<a [routerLink]="['/vehicle-trips']" class="text-secondary"> Vehicle Trips</a> /<span class="text-secondary">
        Events</span></small>
  </div>
</div>

<div class="row mt-3 mb-2 no-gutters">
  <div class="col">
    <div>
      <!-- <ngx-json-viewer [json]="tripEvents" [expanded]="false"></ngx-json-viewer> -->
    </div>
    <div class="text-right">
      <span *ngIf="pageIndex > 0" class="pointer" (click)="prevPage()"><< Previous</span>
      <span class="pointer" (click)="nextPage()">&nbsp;&nbsp;&nbsp;&nbsp;Next >> </span>
    </div>
  </div>
</div>